<div class="skl-ai-config" aria-busy="true" aria-label="Loading AI code assessment settings">
  <app-skeleton width="250px" height="18px" borderRadius="4px" marginBottom="20px" class="d-block"></app-skeleton>

  <div class="skl-tabs">
    @for (tab of tabs; track tab) {
      <app-skeleton [width]="tab === 1 ? '110px' : '170px'" height="32px" borderRadius="16px" marginBottom="0"></app-skeleton>
    }
  </div>

  <div class="skl-panel">
    <app-skeleton width="420px" height="13px" borderRadius="3px" marginBottom="20px"></app-skeleton>

    <div class="skl-card">
      <div class="skl-card__body">
        <app-skeleton width="240px" height="18px" borderRadius="4px" marginBottom="18px"></app-skeleton>

        @for (row of summaryRows; track row) {
          <div class="skl-summary-row">
            <app-skeleton width="170px" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton>
            <app-skeleton [width]="row === 1 ? '34%' : row === 2 ? '48%' : row === 3 ? '28%' : row === 4 ? '18%' : row === 5 ? '52%' : '84px'" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton>
          </div>
        }

        <div class="skl-actions">
          <app-skeleton width="118px" height="38px" borderRadius="4px" marginBottom="0"></app-skeleton>
          <app-skeleton width="156px" height="38px" borderRadius="4px" marginBottom="0"></app-skeleton>
        </div>
      </div>
    </div>

    <div class="skl-card">
      <div class="skl-card__body">
        <app-skeleton width="140px" height="18px" borderRadius="4px" marginBottom="12px"></app-skeleton>
        <app-skeleton width="220px" height="13px" borderRadius="3px" marginBottom="18px"></app-skeleton>

        <div class="skl-table-wrap">
          <div class="skl-table-row skl-table-row--header">
            @for (col of versionCols; track col) {
              <div class="skl-table-cell">
                <app-skeleton [width]="col === 1 ? '54%' : col === 4 ? '40%' : '68%'" height="12px" borderRadius="3px" marginBottom="0"></app-skeleton>
              </div>
            }
          </div>

          @for (row of versionRows; track row) {
            <div class="skl-table-row skl-table-row--data">
              @for (col of versionCols; track col) {
                <div class="skl-table-cell">
                  @if (col === 5) {
                    <app-skeleton width="76px" height="30px" borderRadius="4px" marginBottom="0"></app-skeleton>
                  } @else {
                    <app-skeleton [width]="col === 1 ? '48%' : col === 2 ? '72%' : col === 3 ? '58%' : '44%'" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton>
                  }
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>